import { Meta } from '~/components/common/meta'
import { PageLayout } from '~/components/layout/page'
import { RtbGamePlay } from '~/components/sections/homepage/rtb-game-play'
import { FAQ } from '~/components/sections/pricing/faq'
import { Contracts } from '~/components/sections/protocol/contracts'
import Blocks from '~/components/theme-ui/Blocks'
import BusGrid from '~/components/theme-ui/BusGrid'
import Info from '~/components/theme-ui/Info'

const About = () => {
  return (
    <PageLayout>
      <Meta title="About | Ride the Bus" />

      <RtbGamePlay />
      {/* <Quotes />
        <DebugWithFriends />
        <Features />
        <Testimonials />
        <Security />
        <TrustedTeams /> */}

      <BusGrid />
      <Info />
      <Blocks />
      {/* <Carousel /> */}
      <Contracts />
      <FAQ />
      <br />
      <br />
    </PageLayout>
  )
}

export default About
